const SET_HAPPENING = 'SET_HAPPENING';
const SET_HAPPENING_NON_CONTENT = 'SET_HAPPENING_NON_CONTENT';
const RESET_HAPPENING_IS_INITIALIZED = 'RESET_HAPPENING_IS_INITIALIZED';
const SET_FILTERED_EVENTS = 'SET_FILTERED_EVENTS';
const SET_SHOP_MY_STORE = 'SET_SHOP_MY_STORE';
const SET_SHOP_SAME_DAY = 'SET_SHOP_SAME_DAY';
const SET_SHOP_MY_STORE_SALE_ITEMS = 'SET_SHOP_MY_STORE_SALE_ITEMS';
const SET_SHOP_SAME_DAY_SALE_ITEMS = 'SET_SHOP_SAME_DAY_SALE_ITEMS';
const SHOW_SDU_LANDING_PAGE_MODAL = 'SHOW_SDU_LANDING_PAGE_MODAL';
const SET_STORE_AND_DELIVERY_SLA = 'SET_STORE_AND_DELIVERY_SLA';

export {
    SET_HAPPENING,
    SET_HAPPENING_NON_CONTENT,
    RESET_HAPPENING_IS_INITIALIZED,
    SET_FILTERED_EVENTS,
    SET_SHOP_MY_STORE,
    SET_SHOP_SAME_DAY,
    SHOW_SDU_LANDING_PAGE_MODAL,
    SET_SHOP_MY_STORE_SALE_ITEMS,
    SET_SHOP_SAME_DAY_SALE_ITEMS,
    SET_STORE_AND_DELIVERY_SLA
};
